import React, { useEffect, useState } from 'react';
import productApi from '../../api/product';
import AppApi from '../../api/app';
import moment from 'moment';
import { useSelector } from 'react-redux';
import ResponsivePagination from 'react-responsive-pagination';
import { Offcanvas } from 'react-bootstrap';
import UpdateOrder from '../forms/updateOrder';


const UserOrders = ({ userId }) => {

 let [data, setData] = useState({});
 const [currentPage, setCurrentPage] = useState(1);
 const [editData, setEditData] = useState({});
 const [loading, setLoading] = useState(false);
 const [show, setShow] = useState(false);

 let setting = useSelector(data => data?.profile?.data?.setting);



 useEffect(() => {
  getOrdersList(currentPage);
 }, []);


 const getOrdersList = (page) => {
  try {
   setLoading(true);
   productApi.getUserOrders(userId, page).then(async res => {
    if (res?.data?.data) {
     setData({
      data: res?.data?.data?.data,
      page: res?.data?.data?.page,
      limit: res?.data?.data?.perPage,
      totalPages: res?.data?.data?.totalPages,
      total: res?.data?.data?.total
     });
     setLoading(false);
     setCurrentPage(res?.data?.data?.page)
    }
   })
  } catch (error) {
   console.log("brands getting error", error.message)
  }
 }

 const updateList = () => {
  setShow(false)
 }

 return (
  <div>
   <h4>User Orders</h4>
   <hr className='my-0' />
   <div className="table-responsive">
    <table className='table'>
     <thead>
      <tr>
       <th>#</th>
       <th>Name</th>
       <th>Phone</th>
       <th>QTY</th>
       <th>Cost</th>
       <th>Status</th>
       <th>Date</th>
       <th>Action</th>
      </tr>
     </thead>
     <tbody>
      {!loading && data?.data?.map((data, index) => {
       const startItemNumber = (currentPage - 1) * 10;
       return (
        <tr key={index}>
         <td>{startItemNumber + index + 1}</td>
         <td>{data.name}</td>
         <td>{data.phoneNumber}</td>
         <td>{data.productsQuantity}</td>
         <td>{setting?.currencySymbol} {data.totalCost}</td>
         <td>
          {data?.status == "PENDING" && <span className="badge bg-warning">{data?.status}</span>}
          {data?.status == "ACCEPTED" && <span className="badge bg-success">{data?.status}</span>}
          {data?.status == "REJECTED" && <span className="badge bg-danger">{data?.status}</span>}
          {data?.status == "DELIVERED" && <span className="badge bg-success">{data?.status}</span>}
          {data?.status == "RETURNED" && <span className="badge bg-info">{data?.status}</span>}
         </td>
         <td>{moment(data.createdAt).fromNow()}</td>
         <td>
          <button className='btn bg-black text-white text-small'
           onClick={() => {
            setEditData(data);
            setShow(true)
           }}
          > <small>View</small> </button></td>
        </tr>
       )
      })}
      {!loading && data?.data?.length == 0 && (
       <td colSpan={8} className='text-center py-5'>
        No record found
       </td>
      )}
      {loading && (
       <td colSpan={8} className='text-center py-5'>
        Loading...
       </td>
      )}
     </tbody>
    </table>
   </div>
   {!loading && (
    <ResponsivePagination
     current={Number(data?.page)}
     total={data?.totalPages || 0}
     onPageChange={getOrdersList}
    />
   )}
   <Offcanvas
    // responsive="lg"
    className="container w-100 "
    show={show} placement="end" onHide={() => {
     setShow(false)
    }}>
    <Offcanvas.Header closeButton>
     <Offcanvas.Title>Order Details</Offcanvas.Title>
    </Offcanvas.Header>
    <Offcanvas.Body className='py-0'>
     <UpdateOrder setting={setting} updateList={updateList} data={editData} />
    </Offcanvas.Body>
   </Offcanvas>
  </div >
 );
}


export default UserOrders;